<template lang="pug">

	-
		// set up some variables
		var locales = [
				{code:"au", link:"http://thecollectiveinoz.com.au?allow_browsing",},
				{code:"uk", link:"http://thecollectivedairy.com?allow_browsing"},
				{code:"ie", link:"http://thecollectivedairy.ie?allow_browsing"},
				{code:"nz", link:"http://thecollective.kiwi?allow_browsing"},
				{code:"fr", link:"http://thecollective.fr?allow_browsing"}
		]

		var theme = '/wp-content/themes/collective/images/aus';

	div
		#header.nav-wrapper
			.container
				.logo
					a(href="/")
						img.visible-menu-closed(src='/wp-content/themes/collective/images/header/logo.svg')
						img.visible-menu-open(src='/wp-content/themes/collective/images/header/logo-open.svg')
				.menu-button(@click="toggleNav").visible-xs
					i.icon.menu&attributes({
						":class" : "{closed : !showNav, black : !showNav}"
					})
			//- copied directly from old header
			<div class='container' id='mobile-search-nav'>
				<form role="search" method="get" id="searchform" class="searchform" action="/">
					<input type="text" value="" name="s" class="form-field" id="s" />
					<input type='submit' id='mobile-header-searchform-submit' value='go'>
				</form>
			</div>
			//-
			.nav
				.blocks.hidden-sm.hidden-md.hidden-lg.blocks--xs
					.block.block
						.parent
								a(href="/") 
									i.icon.home
					.block.block
						.parent
								a(href="tel:1800822160") 
									i.icon.phone
					.block.block
						.parent
								a(href="/getting-in-touch") 
									i.icon.envelope
					.block.block
						.parent
								a(href="#") 
									i.icon.search-mobile
				.blocks.hidden-xs
						.block.block--home
								.parent
										a(href="/") 
											img(src=`${theme}/icon_hm.svg`)
											.hidden-sm.u--inline home
						.block(v-for="parent in items")
								.parent
										a(:href="parent.url") {{parent.title}}
								.children(v-if="parent.children")
										.child(v-for="child in parent.children") 
												a(:href="child.url") {{child.title}}
						.block.block--locale
							.parent
								.locale-select__active
									.locale-select__locale
										a(href=locales[0].link)
											img(src=`/wp-content/themes/collective/images/flags/${locales[0].code}-sm.svg`).locale-select__flag
											span= locales[0].code
							.children
								.locale-select__list
									each locale in locales
										.locale-select__locale
											a(href=locale.link)
												img(src=`/wp-content/themes/collective/images/flags/${locale.code}-sm.svg`).locale-select__flag
												span= locale.code
						.block.block--search.hidden-sm
							//- copied directly from old header
							<div class='module search hidden-xs text-right'>
								<i class='icon search'></i>
								<form role="search" method="get" id="searchform" class="searchform" action="/">
									<input type="text" value="" name="s" class="form-field" id="s" />
									<div id='searchform-inner-wrapper'>
										<input type='submit' id='header-searchform-submit' value='go'>
									</div>
								</form>
							</div>
							//-
		.nav-xs(v-if="showNav")
			.nav-xs__block(v-for="(parent, index) in menu.items")
				a&attributes({
					":href" : "parent.url",
					"@click" : "handleNavClick(parent, index, $event)"
				}) 
					span.plus-minus {{parent.expanded ? '-' : '+'}}
					span {{parent.title}}
				ul.nav-xs__subnav(:class="{'is-collapsed':!(parent.children && parent.expanded)}")
					li(v-for="child in parent.children")
						a(:href="child.url") {{child.title}}
</template>  

<script>

import '@babel/polyfill'

import axios from 'axios';

export default {
	name:"the-navigation",
	data() {
		return {
			menu:{
				// place holdery hack
				items:[{title:'',slug:''},{title:'',slug:''},{title:'',slug:''},{title:'',slug:''}]
			},
			activeLocale: "au",
			locales: ["au", "uk", "ie", "nz", "fr"],
			showNav: false
		};
	},
	computed: {
		items() {
			return this.menu.items;
		}
	},
	created(){
		axios.get('/wp-json/wp-api-menus/v2/menus/77').then((response)=>{
			this.menu.items = response.data.items
		}).catch((err)=>{
			// eslint-disable-next-line
			console.log(err);
		})
	},
	methods:{
		toggleNav(){
			this.showNav = !this.showNav;

			if(this.showNav){
				document.body.classList.add('menu-open')
			} else {
				document.body.classList.remove('menu-open')
			}
		},
		handleNavClick(parent, index, e){

			

			if(parent.expanded){
				//this.menu.items[index].expanded = false
				return true
			} else {
				
				this.menu.items.forEach((element, i) => {
						this.$set(this.menu.items[i], 'expanded', false);
				});

				this.$set(this.menu.items[index], 'expanded', true);
				
				e.preventDefault();
				e.stopPropagation();
				
			}
		}
	}
};
</script>

<style lang="scss" scoped>
// variables
$navigationHeight: 60px;
$brand-dark: #181d24;
//$brand-light: #fffcdb;
$brand-light: #fefce7;

.nav-wrapper {
	background-color: $brand-dark;
}

.nav {
	background-color: $brand-dark;
	color: $brand-light;
	max-width: 1170px;
	margin: 0 auto;
}

.blocks {
	display: flex;
	height: $navigationHeight;
}

.block {
	position: relative;
	flex-grow: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	margin: 0 5px;

	&:not(:last-child):after {
		content: "";
		position: absolute;
		width: 10px;
		right: -10px;
		top: 15px;
		bottom: 15px;
		color: $brand-light;
		background: url(data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20100%20100%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%3Ccircle%20fill%3D%22%23fffcdb%22%20cx%3D%2250%22%20cy%3D%2250%22%20r%3D%2225%22/%3E%0A%3C/svg%3E);
	}

	&--locale{
		&:after{
			display: none;
		}
	}

	&:hover {
		.children {
			display: block;
		}
	}


	&--home, &--locale, {
		a{
			white-space: nowrap;
			display: inline;
		}
	}

	&--locale{
		justify-content: left;
		flex-grow: 0.5;

		@media (max-width: 991px){
			flex-grow: 0.9;
		}

		.parent{
			transform: translate(10px, 5px);
		}
		&:hover{
			.parent{
				background-color: $brand-light;
				border-radius: 4px;
				width: calc(100% - 20px);
				a{
					text-decoration: none;
					color: $brand-dark;
					span{
						color: $brand-dark !important;
					}
				}
			}
		}
	}

	&--home{
		img{
			width: 24px;
			margin-right: 8px;
			margin-top: -4px;
		}
	}

	&--search{
		flex-grow: 0;
		img{
			width: 18px;
		}
	}

}

.parent {
	position: relative;
	z-index: 1;
	font-family: "Collective", sans-serif;
}

.children {
	display: none;
	position: absolute;
	top: 10px;
	left: 10px;
	right: 10px;
	padding-top: $navigationHeight - 10px;
	background-color: transparentize($brand-dark, 0.22);
	border: 3px solid $brand-light;
	border-radius: 5px;
}

.child {
	margin: 5px 0px 10px;
	position: relative;
	font-family: "Calibri", sans-serif;
	font-weight: bold;
	padding: 4px;

	&:not(:last-child):after {
		content: "";
		position: absolute;
		//width: 10px;
		height: 6px;
		left: 10px;
		right: 10px;
		bottom: -8px;
		color: $brand-light;
		background-repeat: space;
		background: url(data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20150%20100%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%3Ccircle%20fill%3D%22%23fffcdb%22%20cx%3D%2275%22%20cy%3D%2250%22%20r%3D%2225%22/%3E%0A%3C/svg%3E);
	}
}


a {
	color: $brand-light;
	font-size: 18px;
	text-decoration: none;
	padding: 4px 5px;
	border-radius: 4px;
	display: block;
	&:hover{
		text-decoration: underline;
	}
}
.child{
	a:hover {
		background-color: $brand-light;
		color: $brand-dark;
		text-decoration: none;
	}
}

.locale-select__locale {
	text-transform: uppercase;
	font-family: "Collective", sans-serif;
	white-space: nowrap;
	text-align: left;
	margin: 10px 0;
}

.locale-select__flag{
	/* width: 48px; */
	width: 30px;
	margin-left: 10px;
    margin-right: 10px;
}

.locale-select__arrow{
	width: 16px;
	margin-left: 12px;
}

.nav-xs{
	//background-color: transparentize($brand-dark, 0.22);
	background-color: transparentize($brand-dark, 0.1);
	position: fixed;
	top: 70px;
	bottom: 0;
	z-index: 98;
	right: 0;
	padding: 32px 16px;
	border-radius: 12px;

	a{
		font-size: 24px;
		font-weight: bold;
	}

	.plus-minus{
		display: inline-block;
		width: 0.75em;
	}
}

.nav-xs__subnav{
	list-style-type: none;
	overflow: hidden;
	height: auto;
	padding-left: 20px;
	//margin-bottom: 0;
 
	a{
		font-size: 20px;
		font-weight: bold;
	}

	&.is-collapsed{
		height: 0;
	}
}

.blocks--xs{
	.block{
		flex-grow: 0;
		i{
			margin: 5px;
		}
	}
}

.nav-xs__block{
	position: relative;
	&:after {
		content: "";
		position: absolute;
		//width: 10px;
		height: 6px;
		left: 0px;
		right: 0px;
		bottom: -8px;
		color: $brand-light;
		background-repeat: space;
		background: url(data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20150%20100%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%3Ccircle%20fill%3D%22%23fffcdb%22%20cx%3D%2275%22%20cy%3D%2250%22%20r%3D%2225%22/%3E%0A%3C/svg%3E);
	}
}

.icon-xs{
	width: 24px;
}

// utilities
.u--text-uppercase {
	text-transform: uppercase;
}

.u--inline{
	display: inline;
}
</style>
